var _style, _g, _g2, _polyline;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColumnCustomize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.9 20.4",
    style: {
      enableBackground: "new 0 0 20.9 20.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#C8C8C8;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#C8C8C8;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 4.8,
    y1: 6.1,
    x2: 4.8,
    y2: 15.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14.8,
    y1: 12.5,
    x2: 14.8,
    y2: 15.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.8,
    y1: 14.3,
    x2: 9.8,
    y2: 15.2
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.3,10.2c-0.3,0.3-0.8,0.6-1.2,0.6l-1.9,0.4c-0.4,0.1-0.6-0.2-0.5-0.5l0.4-1.9c0.1-0.4,0.4-0.9,0.6-1.2 l5.1-5.1c0.3-0.3,0.7-0.3,1,0L18.4,4c0.3,0.3,0.3,0.7,0,1L13.3,10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.9,3.5c-0.3,0.3-0.7,0.3-1,0L17.4,2c-0.3-0.3-0.3-0.7,0-1l0.8-0.8c0.3-0.3,0.7-0.3,1,0l1.5,1.5 c0.3,0.3,0.3,0.7,0,1L19.9,3.5z"
  })))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "9.8,1.6 0.8,1.6 0.8,19.6 18.8,19.6 18.8,11.5 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnCustomize);
export default __webpack_public_path__ + "static/media/column_customize.4c699b32bc43b071daf3db7ff6d7d521.svg";
export { ForwardRef as ReactComponent };